import React, { PureComponent } from 'react';
import { bool, func } from 'prop-types';
import SnackBar from '@material-ui/core/Snackbar';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { emptyFunction } from '../../core/util/function';
import { colors } from '../../constants/colors';

const StyledSnackBar = styled(SnackBar).withConfig({ componentId: 'sc-s3gkg4-0' })`
  max-width: 348px;
  margin: auto;
  transform: translateY(-15px);
  div {
    background-color: ${colors.myRightFoot};
    border-radius: 5px;
  }
`;

type OwnProps = {
  action?: any;
  anchorOrigin?: object;
  autoHideDuration?: number;
  // @ts-expect-error ts-migrate(2749) FIXME: 'bool' refers to a value, but is being used as a t... Remove this comment to see the full error message
  canClickToClose?: bool;
  classes?: object;
  className?: string;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  onClose?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'bool' refers to a value, but is being used as a t... Remove this comment to see the full error message
  open: bool;
};

type State = any;

type Props = OwnProps & typeof SolvSnackBar.defaultProps;

class SolvSnackBar extends PureComponent<Props, State> {
  static defaultProps = {
    autoHideDuration: 2000,
    onClose: emptyFunction,
    anchorOrigin: {
      horizontal: 'left',
      vertical: 'bottom',
    },
  };

  constructor(props: Props) {
    super(props);

    this.state = { open: !!props.open };
  }

  componentDidUpdate = (prevProps: any) => {
    if (!prevProps.open && this.props.open) {
      this.setState({ open: true }); // eslint-disable-line react/no-did-update-set-state
    }

    if (prevProps.open && !this.props.open) {
      this.setState({ open: false }); // eslint-disable-line react/no-did-update-set-state
    }
  };

  getCloseX = () => (
    <IconButton aria-label="close" color="inherit" key="close" onClick={this.handleOnClose}>
      <CloseIcon />
    </IconButton>
  );

  handleOnClose = () => {
    this.setState({ open: false });
    this.props.onClose();
  };

  render = () => {
    const {
      anchorOrigin,
      canClickToClose,
      children,
      classes,
      action,
      autoHideDuration,
      className,
    } = this.props;
    const { open } = this.state;
    return (
      <StyledSnackBar
        action={[action, canClickToClose && this.getCloseX()]}
        // @ts-expect-error ts-migrate(2769) FIXME: Type 'object & { horizontal: string; vertical: str... Remove this comment to see the full error message
        anchorOrigin={anchorOrigin}
        autoHideDuration={autoHideDuration}
        classes={classes}
        className={className}
        message={children}
        onClose={this.handleOnClose}
        open={open}
      />
    );
  };
}

export default SolvSnackBar;
